module.exports = __webpack_public_path__ + "img/stepper2.fd1857b6.png";